<template>
  <div class="bg-pink">
    <div class="bg-line">
      <header>
        <img src="@img/img_logo.png" class="logo" />
        <h2 class="title">隱私權條款</h2>
      </header>
      <section class="content">
        <div v-for="(content, index) in contents" :key="index">
          <h5
            v-if="content.title"
            class="subject"
            :class="{ 'fw-bold': !content.id.includes('.') }"
          >
            {{ content.id }}. {{ content.title }}
          </h5>
          <p>{{ content.text }}</p>
        </div>
        <div>
          <h5 class="subject fw-bold">電話: {{ phone }}</h5>
          <h5 class="subject fw-bold">{{ email }}</h5>
        </div>
      </section>
      <img src="@img/img_bottom.png" class="bottom" />
    </div>
  </div>
</template>

<script>
import privacyData from '@/assets/privacyData.js'

export default {
  name: 'Privacy',
  data() {
    return {
      contents: [],
      phone: '',
      email: '',
    }
  },
  created() {
    this.importData()
  },
  methods: {
    importData() {
      this.contents = privacyData.contents
      this.phone = privacyData.phone
      this.email = privacyData.email
    },
  },
}
</script>

<style lang="scss" scoped>
.bg-pink {
  background-size: 576px;
  background-attachment: fixed;
  background-position: center 0;
  background-color: none;
}

.bg-line {
  position: relative;
  background: url('~@img/privacy/prv_BGLine.png') no-repeat;
  background-size: 100%;
}

header {
  position: relative;
  padding-top: 10%;
  margin-bottom: 10%;

  .logo {
    width: 15%;
    position: absolute;
    top: 0;
    left: 5%;
  }

  .title {
    text-align: center;
    font-weight: bold;
    font-size: 1.7rem;
  }
}

section.content {
  padding: 0 8%;

  .subject {
    margin-bottom: 0;
    font-size: 0.9rem;
  }

  p {
    white-space: pre-line;
    font-size: 0.8rem;
  }
}

.bottom {
  width: 100%;
  margin-top: -3%;
}
</style>